import { formatDateTime } from '../../utils/userManagementFormatters'
import type { UserManagementEditHeaderProps } from '../../types'

export function UserManagementEditHeader({
  userId,
  lastActive,
  updatedAt,
  loginCount,
  avgLogin,
}: UserManagementEditHeaderProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-x-6 gap-y-2 text-xs">
      <div>
        <span className="font-bold text-slate-900 block">UserID</span>
        <span className="font-medium text-slate-600">{userId}</span>
      </div>
      <div>
        <span className="font-bold text-slate-900 block">Last Access Date</span>
        <span className="font-medium text-slate-600">{formatDateTime(lastActive) || '—'}</span>
      </div>
      <div>
        <span className="font-bold text-slate-900 block">Updated</span>
        <span className="font-medium text-slate-600">{formatDateTime(updatedAt) || '—'}</span>
      </div>
      <div>
        <span className="font-bold text-slate-900 block">Login Total</span>
        <span className="font-medium text-slate-600">{loginCount ?? 0}</span>
      </div>
      <div>
        <span className="font-bold text-slate-900 block">Login Monthly Avg</span>
        <span className="font-medium text-slate-600">{(avgLogin ?? 0).toFixed(2)}</span>
      </div>
    </div>
  )
}
